import "./pages/Login";
import DashBoard from "./pages/DashBoard";
import "./App.css";
import TripBooking from "./pages/TripBooking";
import BusesPage from "./pages/Buses";
import UserManagement from "./pages/UserManagement";
import Driver from "./pages/Driver";
import TripClosure from "./pages/TripClosure";
import Customer from "./pages/Customer";
import MasterSetup from "./pages/MasterSetup";
import MaintenanceRecord from "./pages/MaintenanceRecord";
import ExpenseTracker from "./pages/ExpenseTracker";
import ExecutiveDashBoard from "./pages/ExecutiveDashBoard";
import Date from "./pages/Date";
import AssetSetup from "./pages/AssetSetup";
import Asset from "./pages/Asset";
import Capital from "./pages/Capital";
import ExpenseReport from "./pages/ExpenseReport";
import FeedbackForm from "./pages/Components/Feedback";
import RouteError from "./pages/Components/ErrorBoundry";
import React, { useEffect } from 'react'

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import LoginData from "./pages/LoginData";
// import Cities from "./pages/Components/Cities";
import LocationAutocomplete from "./pages/LocationAutoComplete";
import MaintenanceReport from "./pages/MaintenanceReport";
// import Cities from "./pages/Components/Cities";

const App = () => {
  const { keycloak, initialized } = useKeycloak();
  console.log(keycloak, initialized);
  let roles, data;

  useEffect(() => {
      if (initialized) {
        // Save initial token in session storage
        updateSessionStorage(keycloak);
  
        // Listen for token refresh or expiration
        keycloak.onAuthSuccess = async() => await updateSessionStorage(keycloak);
        keycloak.onAuthRefreshSuccess = async() => await updateSessionStorage(keycloak);
        keycloak.onTokenExpired = async() => await handleTokenExpiry();
      }
    
  }, [initialized,keycloak.token]);

  const updateSessionStorage = async(keycloak) => {
    if (keycloak.token) {
      sessionStorage.setItem("access_token", keycloak.token);
      sessionStorage.setItem("refresh_token", keycloak.refreshToken);
      roles = await keycloak.tokenParsed.realm_access.roles;
  
      sessionStorage.setItem("id_token", keycloak.idToken);
      sessionStorage.setItem("realm", keycloak.realm);
      sessionStorage.setItem("client", keycloak.clientId);

        let username= keycloak.tokenParsed.preferred_username
        let rights= roles.includes("view-dashboard") ? "A" : "E"
  
      sessionStorage.setItem("username", username);
      sessionStorage.setItem("rights",rights);
    }
  };

  const handleTokenExpiry = async() => {
    console.warn("Token expired. Refreshing...");
    await keycloak.updateToken(40).then((refreshed) => {
      if (refreshed) {
        console.log("Token refreshed successfully.");
        updateSessionStorage(keycloak);
      } else {
        console.warn("Token refresh failed. Redirecting to login...");
        keycloak.logout();
      }
    }).catch(() => {
      console.error("Error refreshing token. Logging out...");
      keycloak.logout();
    });
  };

  
  const router = createBrowserRouter([
    {
      path: "/",
      element: <LoginData />,
      errorElement: <RouteError />,
    },
    {
      path: "/DashBoard",
      element: <DashBoard />,
      errorElement: <RouteError />,
    },
    {
      path: "/TripBooking",
      element: <TripBooking />,
      errorElement: <RouteError />,
    },
    {
      path: "/Buses",
      element: <BusesPage />,
      errorElement: <RouteError />,
    },
    {
      path: "/UserManagement",
      element: <UserManagement />,
      errorElement: <RouteError />,
    },
    {
      path: "/MaintenanceRecord",
      element: <MaintenanceRecord />,
      errorElement: <RouteError />,
    },
    {
      path: "/Driver",
      element: <Driver />,
      errorElement: <RouteError />,
    },
    {
      path: "/TripClosure",
      element: <TripClosure />,
      errorElement: <RouteError />,
    },
    {
      path: "/Customer",
      element: <Customer />,
      errorElement: <RouteError />,
    },
    {
      path: "/MasterSetup",
      element: <MasterSetup />,
      errorElement: <RouteError />,
    },
    {
      path: "/ExpenseTracker",
      element: <ExpenseTracker />,
      errorElement: <RouteError />,
    },
    {
      path: "/ExecutiveDashboard",
      element: <ExecutiveDashBoard />,
      errorElement: <RouteError />,
    },
    {
      path: "/Date",
      element: <Date />,
      errorElement: <RouteError />,
    },
    {
      path: "/AssetSetup",
      element: <AssetSetup />,
      errorElement: <RouteError />,
    },
    {
      path: "/Asset",
      element: <Asset />,
      errorElement: <RouteError />,
    },
    {
      path: "/Capital",
      element: <Capital />,
      errorElement: <RouteError />,
    },
    {
      path: "/ExpenseReport",
      element: <ExpenseReport />,
      errorElement: <RouteError />,
    },
    {
      path: "/MaintenanceReport",
      element: <MaintenanceReport />,
      errorElement: <RouteError />,
    },
    {
      path: "/Feedback/:id",
      element: <FeedbackForm />,
      errorElement: <RouteError />,
    }
  ]);


  return (
    <div>
      <RouterProvider router={router} />
    </div>
  )
}

export default App
